export interface LegendOption {
  title: string;
};

export const LEGEND_OPTION_OFF: LegendOption = {
  title: 'Off'
};

export const LEGEND_OPTION_MINIMAL: LegendOption = {
  title: 'Minimal'
};

export const LEGEND_OPTION_DEFAULT: LegendOption = {
  title: 'Default'
};

export const LEGEND_OPTION_VERBOSE: LegendOption = {
  title: 'Verbose'
};

export const DEFAULT_LEGEND_OPTION: LegendOption = LEGEND_OPTION_VERBOSE;

export const LEGEND_OPTIONS_ARRAY: LegendOption[] = [
  LEGEND_OPTION_OFF,
  LEGEND_OPTION_MINIMAL,
  LEGEND_OPTION_DEFAULT,
  LEGEND_OPTION_VERBOSE
];
